import { Typography, Button, PhoneIcon } from '@ag1/ui';
import style from './Support.module.scss';
import { routes } from '../../../constants/routes';
import { SupportContactProps } from './Support.types';

const SupportContact = (props: SupportContactProps) => {
  const { title, businessHours, description, phone, phoneHref, linkFAQ, className } = props;

  return (
    <div className={className}>
      <div className={style.support}>
        <Typography
          variant="portalSubtitleBold"
          size="2"
          color="grey-1-new"
          component="h6"
          noPadding>
          {title}
        </Typography>
        {businessHours ? (
          <Typography
            className={style.businessHours}
            variant="portalText"
            size="1"
            color="black-new"
            noPadding>
            {businessHours}
          </Typography>
        ) : (
          ''
        )}
        <div className={style.items}>
          <Button
            variant="link"
            theme="new"
            size={{ s: 'medium', xxs: 'small' }}
            href={`tel:${phoneHref}`}
            icon={<PhoneIcon size={24} />}
            className={style.item}>
            {phone}
          </Button>
        </div>
        <Typography variant="portalText" size="1" color="black-new" noPadding>
          {description}{' '}
          <a
            href={routes.faq}
            target="_blank"
            aria-label={`${linkFAQ} (Opens in a new tab)`}
            rel="noreferrer"
            className={style.link}>
            {linkFAQ}
          </a>
        </Typography>
      </div>
    </div>
  );
};

export default SupportContact;
